import { useState } from 'react';

export const useDashboard = () => {
    const [searchText, setSearchText] = useState('');

    return {
        searchText,
        setSearchText
    }
}